import { isIOS } from "@/lib/mobileUtils";

export const onFocusDialogKeyboard = (view: "people" | "events", event: React.FocusEvent) => {
  if (!isIOS()) return;
  setTimeout(() => {
    const updateStyles = (element: Element | null, styles: Record<string, string>) => {
      if (element) {
        Object.entries(styles).forEach(([key, value]) => {
          (element as HTMLElement).style.setProperty(key, value);
        });
      }
    };
    const inputTarget = event.target as HTMLInputElement;
    // iOS bug: keyboard moves the input up, so we need to move the modal down
    const translateSpace = inputTarget.value ? "translateY(0)" : "translateY(-20em)";
    if (view === "people") {
      const modalElement = document.querySelector("md-dialog");
      const shadowContent = modalElement?.shadowRoot?.querySelector(".content");
      if (shadowContent) {
        updateStyles(shadowContent, { transform: "" });
      }

      const content = modalElement?.querySelector('div[slot="content"]');
      if (content) {
        updateStyles(content, { "overflow-y": "scroll", transform: translateSpace });
        const scroller = modalElement?.shadowRoot?.querySelector(".scroller");
        if (scroller) {
          scroller?.addEventListener("scroll", () => {
            updateStyles(content, { "overflow-y": "hidden", height: "auto", transform: "translateY(0)" });
          });
        }
      }

      content?.scrollTo({
        top: content.scrollHeight,
        behavior: "smooth"
      });
    }

    if (view === "events") {
      const modalElement = document.querySelector("main");
      updateStyles(modalElement, { transform: translateSpace });
    }
  }, 200);
};

export const onBlurDialogKeyboard = (view: "people" | "events") => {
  if (!isIOS()) return;
  setTimeout(() => {
    const updateStyles = (element: Element | null, styles: Record<string, string>) => {
      if (element) {
        Object.entries(styles).forEach(([key, value]) => {
          (element as HTMLElement).style.setProperty(key, value);
        });
      }
    };

    if (view === "people") {
      const modalElement = document.querySelector("md-dialog");
      const shadowContent = modalElement?.shadowRoot?.querySelector(".content");
      if (shadowContent !== undefined) {
        updateStyles(shadowContent, { transform: "translateY(0)" });
      }

      const content = modalElement?.querySelector('div[slot="content"]');
      if (content !== undefined) {
        updateStyles(content, { "overflow-y": "hidden", height: "auto", transform: "translateY(0)" });
      }
    }

    if (view === "events") {
      const modalElement = document.querySelector("main");
      updateStyles(modalElement, { transform: "translateY(0)" });
    }
  }, 200);
};
